import React, { JSX, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "./redux/store";
import { listenForAuthChanges } from "./redux/authSlice";
import AuthSwitch from "./AUTH/AuthSwitch";
import GroupHome from "./GROUP/GroupHome";
import Careers from "./GROUP/Careers";
import Companies from "./GROUP/Companies";
import Application from "./GROUP/Application";
import ContactUs from "./GROUP/ContactUs";
import EditPages from "./DASHBOARD/EDITORIAL/EDIT/PAGES/EditPages";
import EPageContent from "./DASHBOARD/EDITORIAL/EDIT/PAGES/EPageContent";
import EArticle from "./DASHBOARD/EDITORIAL/EDIT/POSTS/EArticle";
import EditPost from "./DASHBOARD/EDITORIAL/EDIT/POSTS/EditPosts";
import MoreNews from "./DASHBOARD/EDITORIAL/EDIT/POSTS/MoreNews";
import News from "./DASHBOARD/EDITORIAL/EDIT/POSTS/News";
import Editorial from "./DASHBOARD/EDITORIAL/Editorial";
import { Man } from "@mui/icons-material";
import Management from "./DASHBOARD/MANAGEMENT";
import Profile from "./AUTH/Profile";
import InvestPage from "./GROUP/Invest";
import DonatePage from "./GROUP/Donate";






const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  return user ? element : <Navigate to="/emaillogin" replace />;
};

const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(listenForAuthChanges());
  }, [dispatch]);


  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={
        <>
          <GroupHome />
        </>



      } />
      <Route path="/authswitch" element={<AuthSwitch />} />

            {/* Normal app routes */}
<Route path="/editpages/:pageId" element={<EditPages />} /> 
<Route path="/edit-post/:postId" element={<EditPost />} /> 
<Route path="/:slug" element={<EArticle />} /> 
<Route path="/MoreNews" element={<MoreNews />} />
 <Route path="/News" element={<News />} /> 
<Route path="/:slug" element={<EPageContent />} />
<Route path="/editorial" element={<Editorial />} />


<Route path="/careers" element={<Careers />} />
<Route path="/Companies" element={<Companies />} />
<Route path="/Application" element={<Application />} />
<Route path="/Contact" element={<ContactUs />} />
<Route path="/invest" element={<InvestPage />} />
<Route path="/donate" element={<DonatePage />} />


<Route path="/management/:userId" element={<Management />} />

<Route path="/profile/:userId" element={<Profile />} />



      {/* Authenticated Routes */}

      <Route path="*" element={<Navigate to={user ? `/profile/${user.userId}` : "/authswitch"} replace />} />
    </Routes>
  );
};

const App = () => (
  <Provider store={store}>
    <Router>
      <AppRoutes />
    </Router>
  </Provider>
);

export default App;
